import React from "react";
// Customizable Area Start
import {
  Box,
  Snackbar,
  Grid,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";

import EditLoyaltyMultiplierController, {
  Props,
  configJSON,
} from "./EditLoyaltyMultiplierController.web";
import Alert from "@material-ui/lab/Alert";
import { SaveAndCancelButton, HeaderText, DefultBox, SelectFieldCustom, InputLabel, CustomStyledTextField } from "../../../components/src/customComponents/CustomTags.web";
import { CustomSearchableMultiSelect } from "../../../components/src/customComponent/CustomSearchableMultiSelect.web";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";

export default class EditLoyaltyMultiplier extends EditLoyaltyMultiplierController {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const {
      formData,
      formErrors,
      ruleTypes,
      isSubmitting,
      sectionList,
      sectionSelectedData,
      selectedSectionsForList,
      catalogueList,
      catalogueSelectedData,
      selectedCataloguesForList,
      daysOfWeekList,
      selectedDaysOfWeek,
      selectedDaysOfWeekForList,
      upchargeList,
      isLoading,
      platformList,
      platformSelectedData,
      selectedPlatformsForList,
      regionList,
      regionSelectedData,
      selectedRegionsForList,
      areaList,
      areaSelectedData,
      selectedAreasForList,
      storeList,
      storeSelectedData,
      selectedStoresForList
    } = this.state;

    const ruleTypeId = formData.loyalty_multiplier_rule_type_id;

    if (isLoading) {
      return <CustomLoader loading={isLoading} />;
    }

    return (
      <>
        <Box component="div" sx={{...webStyle.mainContainer, width: {xs: 'calc(100% - 100px)', md: 'unset'}}}>
          <HeaderText style={webStyle.header}>Edit Loyalty Multiplier</HeaderText>
          <DefultBox style={webStyle.warningContainer}>
            Update the loyalty multiplier rule to modify how customers earn multiplied points.
          </DefultBox>
          <div style={webStyle.formContainer}>
            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              {/* Name Field */}
              <Grid item xs={12} sm={8} md={6}>
                <InputLabel>Name *</InputLabel>
                <CustomStyledTextField
                  data-test-id='multiplier-name'
                  fullWidth={true}
                  placeholder="Enter rule name"
                  variant='outlined'
                  value={formData.name}
                  onChange={(e) => this.handleInputChange("name", e.target.value)}
                  error={!!formErrors["name"]}
                />
                {formErrors["name"] && (
                  <div style={webStyle.errorText}>{formErrors["name"]}</div>
                )}
              </Grid>

              {/* Description Field */}
              <Grid item xs={12} sm={8} md={6}>
                <InputLabel>Description *</InputLabel>
                <CustomStyledTextField
                  data-test-id='multiplier-description'
                  fullWidth={true}
                  placeholder="Enter description"
                  variant='outlined'
                  multiline
                  rows={3}
                  value={formData.description}
                  onChange={(e) => this.handleInputChange("description", e.target.value)}
                  error={!!formErrors["description"]}
                />
                {formErrors["description"] && (
                  <div style={webStyle.errorText}>{formErrors["description"]}</div>
                )}
              </Grid>
            </Grid>

            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              {/* Multiplier Field */}
              <Grid item xs={12} sm={8} md={3}>
                <InputLabel>Multiplier *</InputLabel>
                <CustomStyledTextField
                  data-test-id='multiplier-value'
                  fullWidth={true}
                  placeholder="0.0"
                  variant='outlined'
                  type="number"
                  inputProps={{
                    step: "0.1",
                    min: "0"
                  }}
                  value={formData.multiplier}
                  onChange={(e) => this.handleInputChange("multiplier", e.target.value)}
                  error={!!formErrors["multiplier"]}
                />
                {formErrors["multiplier"] && (
                  <div style={webStyle.errorText}>{formErrors["multiplier"]}</div>
                )}
              </Grid>

              {/* Rule Type Dropdown */}
              <Grid item xs={12} sm={8} md={3}>
                <InputLabel>Rule Type *</InputLabel>
                <SelectFieldCustom
                  data-test-id='multiplier-rule-type'
                  fullWidth
                  variant='outlined'
                  value={formData.loyalty_multiplier_rule_type_id}
                  onChange={this.handleRuleTypeChange}
                  error={!!formErrors["loyalty_multiplier_rule_type_id"]}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Rule Type
                  </MenuItem>
                  {ruleTypes.map((ruleType) => (
                    <MenuItem key={ruleType.id} value={ruleType.id}>
                      {ruleType.attributes.name}
                    </MenuItem>
                  ))}
                </SelectFieldCustom>
                {formErrors["loyalty_multiplier_rule_type_id"] && (
                  <div style={webStyle.errorText}>{formErrors["loyalty_multiplier_rule_type_id"]}</div>
                )}
              </Grid>
            </Grid>

            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              {/* Section Dropdown */}
              <Grid item xs={12} sm={8} md={6}>
                <InputLabel>Section</InputLabel>
                <CustomSearchableMultiSelect
                  id="section"
                  name="section"
                  dataTestId="sectionDropdown"
                  checkSelectAllText={() => {}}
                  value={sectionSelectedData}
                  optionList={sectionList}
                  placeHolderText="Select Section"
                  changeInputOnClear
                  handleScroll={() => {}}
                  handleClickOnSelectAll={() => {}}
                  isOnBlurFunction={() => {}}
                  debouncedFunction={(getValue: string) => {}}
                  handleSelectOptions={(values: any[], option: any) => {
                    this.handleSectionMultiSelect(values, option);
                  }}
                  emptyDataMessage="No Section Found"
                  handleEmptyAutoSelectValue={() => {}}
                  selectedOptionForList={selectedSectionsForList}
                  isError={false}
                />
              </Grid>

              {/* Product Dropdown */}
              <Grid item xs={12} sm={8} md={6}>
                <InputLabel>Product</InputLabel>
                <CustomSearchableMultiSelect
                  id="product"
                  name="product"
                  dataTestId="productDropdown"
                  checkSelectAllText={() => {}}
                  value={catalogueSelectedData}
                  optionList={catalogueList}
                  placeHolderText={
                    sectionSelectedData.length === 0
                      ? "Select Section First"
                      : "Select Product"
                  }
                  changeInputOnClear
                  handleScroll={this.handleCatalogueScroll}
                  handleClickOnSelectAll={() => {}}
                  isOnBlurFunction={() => this.handleCatalogueSearch("")}
                  debouncedFunction={(getValue: string) => {
                    this.handleCatalogueSearch(getValue);
                  }}
                  handleSelectOptions={(values: any[], option: any) => {
                    this.handleCatalogueMultiSelect(values, option);
                  }}
                  emptyDataMessage="No Product Found"
                  handleEmptyAutoSelectValue={() => {}}
                  selectedOptionForList={selectedCataloguesForList}
                  isError={false}
                  disabled={sectionSelectedData.length === 0}
                />
              </Grid>
            </Grid>

            {/* Region, Area, Platform, Store Filters */}
            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              {/* Region Dropdown */}
              <Grid item xs={12} sm={8} md={6}>
                <InputLabel>Region</InputLabel>
                <CustomSearchableMultiSelect
                  id="region"
                  name="region"
                  dataTestId="regionDropdown"
                  checkSelectAllText={() => {}}
                  value={regionSelectedData}
                  optionList={regionList.map((r) => ({
                    id: r.id,
                    option: r.attributes.name
                  }))}
                  placeHolderText="Select Region"
                  changeInputOnClear
                  handleScroll={() => {}}
                  handleClickOnSelectAll={() => {}}
                  isOnBlurFunction={() => {}}
                  debouncedFunction={(getValue: string) => {}}
                  handleSelectOptions={(values: any[], option: any) => {
                    this.handleRegionMultiSelect(values, option);
                  }}
                  emptyDataMessage="No Region Found"
                  handleEmptyAutoSelectValue={() => {}}
                  selectedOptionForList={selectedRegionsForList}
                  isError={false}
                />
              </Grid>

              {/* Area Dropdown */}
              <Grid item xs={12} sm={8} md={6}>
                <InputLabel>Area</InputLabel>
                <CustomSearchableMultiSelect
                  id="area"
                  name="area"
                  dataTestId="areaDropdown"
                  checkSelectAllText={() => {}}
                  value={areaSelectedData}
                  optionList={areaList.map((a) => ({
                    id: a.id,
                    option: a.attributes.area_name
                  }))}
                  placeHolderText={
                    regionSelectedData.length === 0
                      ? "Select Region First"
                      : "Select Area"
                  }
                  changeInputOnClear
                  handleScroll={() => {}}
                  handleClickOnSelectAll={() => {}}
                  isOnBlurFunction={() => {}}
                  debouncedFunction={(getValue: string) => {}}
                  handleSelectOptions={(values: any[], option: any) => {
                    this.handleAreaMultiSelect(values, option);
                  }}
                  emptyDataMessage="No Area Found"
                  handleEmptyAutoSelectValue={() => {}}
                  selectedOptionForList={selectedAreasForList}
                  isError={false}
                  disabled={regionSelectedData.length === 0}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              {/* Platform Dropdown */}
              <Grid item xs={12} sm={8} md={6}>
                <InputLabel>Platform</InputLabel>
                <CustomSearchableMultiSelect
                  id="platform"
                  name="platform"
                  dataTestId="platformDropdown"
                  checkSelectAllText={() => {}}
                  value={platformSelectedData}
                  optionList={platformList.map((p) => ({
                    id: p.id,
                    option: p.attributes.name
                  }))}
                  placeHolderText="Select Platform"
                  changeInputOnClear
                  handleScroll={() => {}}
                  handleClickOnSelectAll={() => {}}
                  isOnBlurFunction={() => {}}
                  debouncedFunction={(getValue: string) => {}}
                  handleSelectOptions={(values: any[], option: any) => {
                    this.handlePlatformMultiSelect(values, option);
                  }}
                  emptyDataMessage="No Platform Found"
                  handleEmptyAutoSelectValue={() => {}}
                  selectedOptionForList={selectedPlatformsForList}
                  isError={false}
                />
              </Grid>

              {/* Store Dropdown - Only show if "Store" platform is selected */}
              {(() => {
                const selectedPlatforms = this.state.isPlatformSelectAll
                  ? platformList
                  : platformSelectedData
                      .filter((p) => p.id !== "-1")
                      .map((p) => platformList.find((pl) => pl.id === p.id))
                      .filter(Boolean);
                const hasStorePlatform = selectedPlatforms.some((p: any) => p?.attributes?.name === "Store");

                return hasStorePlatform ? (
                  <Grid item xs={12} sm={8} md={6}>
                    <InputLabel>Store</InputLabel>
                    <CustomSearchableMultiSelect
                      id="store"
                      name="store"
                      dataTestId="storeDropdown"
                      checkSelectAllText={() => {}}
                      value={storeSelectedData}
                      optionList={storeList.map((s) => ({
                        id: s.id,
                        option: s.attributes.store_name
                      }))}
                      placeHolderText={
                        areaSelectedData.length === 0
                          ? "Select Area First"
                          : "Select Store"
                      }
                      changeInputOnClear
                      handleScroll={() => {}}
                      handleClickOnSelectAll={() => {}}
                      isOnBlurFunction={() => {}}
                      debouncedFunction={(getValue: string) => {}}
                      handleSelectOptions={(values: any[], option: any) => {
                        this.handleStoreMultiSelect(values, option);
                      }}
                      emptyDataMessage="No Store Found"
                      handleEmptyAutoSelectValue={() => {}}
                      selectedOptionForList={selectedStoresForList}
                      isError={false}
                      disabled={areaSelectedData.length === 0}
                    />
                  </Grid>
                ) : null;
              })()}
            </Grid>

            {/* Conditional Fields Based on Rule Type */}
            {/* Type 1: Day Time Config */}
            {ruleTypeId === "1" && (
              <>
                <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
                  <Grid item xs={12} sm={8} md={6}>
                    <InputLabel>Days of Week *</InputLabel>
                    <CustomSearchableMultiSelect
                      id="daysOfWeek"
                      name="daysOfWeek"
                      dataTestId="daysOfWeekDropdown"
                      checkSelectAllText={() => {}}
                      value={selectedDaysOfWeek}
                      optionList={daysOfWeekList}
                      placeHolderText="Select Days"
                      changeInputOnClear
                      handleScroll={() => {}}
                      handleClickOnSelectAll={() => {}}
                      isOnBlurFunction={() => {}}
                      debouncedFunction={(getValue: string) => {}}
                      handleSelectOptions={(values: any[], option: any) => {
                        this.handleDaysOfWeekMultiSelect(values, option);
                      }}
                      emptyDataMessage="No Days Found"
                      handleEmptyAutoSelectValue={() => {}}
                      selectedOptionForList={selectedDaysOfWeekForList}
                      isError={false}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8} md={3}>
                    <InputLabel>Start Time *</InputLabel>
                    <CustomStyledTextField
                      data-test-id='start-time'
                      fullWidth={true}
                      variant='outlined'
                      type="time"
                      InputLabelProps={{ shrink: true }}
                      value={formData.start_time}
                      onChange={(e) => this.handleInputChange("start_time", e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8} md={3}>
                    <InputLabel>End Time *</InputLabel>
                    <CustomStyledTextField
                      data-test-id='end-time'
                      fullWidth={true}
                      variant='outlined'
                      type="time"
                      InputLabelProps={{ shrink: true }}
                      value={formData.end_time}
                      onChange={(e) => this.handleInputChange("end_time", e.target.value)}
                    />
                  </Grid>
                </Grid>
              </>
            )}

            {/* Type 2: Late Delivery Config */}
            {ruleTypeId === "2" && (
              <>
                <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
                  <Grid item xs={12} sm={8} md={6}>
                    <InputLabel>Days of Week *</InputLabel>
                    <CustomSearchableMultiSelect
                      id="daysOfWeek"
                      name="daysOfWeek"
                      dataTestId="daysOfWeekDropdown"
                      checkSelectAllText={() => {}}
                      value={selectedDaysOfWeek}
                      optionList={daysOfWeekList}
                      placeHolderText="Select Days"
                      changeInputOnClear
                      handleScroll={() => {}}
                      handleClickOnSelectAll={() => {}}
                      isOnBlurFunction={() => {}}
                      debouncedFunction={(getValue: string) => {}}
                      handleSelectOptions={(values: any[], option: any) => {
                        this.handleDaysOfWeekMultiSelect(values, option);
                      }}
                      emptyDataMessage="No Days Found"
                      handleEmptyAutoSelectValue={() => {}}
                      selectedOptionForList={selectedDaysOfWeekForList}
                      isError={false}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8} md={3}>
                    <InputLabel>Delay Hours *</InputLabel>
                    <SelectFieldCustom
                      data-test-id='delay-hours'
                      fullWidth
                      variant='outlined'
                      value={formData.delay_hours}
                      onChange={(e) => this.handleInputChange("delay_hours", e.target.value as string)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>Select Delay Hours</MenuItem>
                      <MenuItem value="48">48 Hours</MenuItem>
                      <MenuItem value="72">72 Hours</MenuItem>
                    </SelectFieldCustom>
                  </Grid>
                </Grid>
              </>
            )}

            {/* Type 3: Special Day Config */}
            {ruleTypeId === "3" && (
              <>
                <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
                  <Grid item xs={12} sm={8} md={4}>
                    <InputLabel>Special Day Name *</InputLabel>
                    <CustomStyledTextField
                      data-test-id='special-day-name'
                      fullWidth={true}
                      placeholder="Enter special day name"
                      variant='outlined'
                      value={formData.special_day_name}
                      onChange={(e) => this.handleInputChange("special_day_name", e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8} md={4}>
                    <InputLabel>Special Day Date *</InputLabel>
                    <CustomStyledTextField
                      data-test-id='special-day-date'
                      fullWidth={true}
                      variant='outlined'
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      value={formData.special_day_date}
                      onChange={(e) => this.handleInputChange("special_day_date", e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8} md={4} style={{ display: "flex", alignItems: "flex-end" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          data-test-id='is-recurring'
                          checked={formData.is_recurring}
                          onChange={(e) => this.setState({
                            formData: {
                              ...this.state.formData,
                              is_recurring: e.target.checked
                            }
                          })}
                          color="primary"
                        />
                      }
                      label="Is Recurring"
                    />
                  </Grid>
                </Grid>
              </>
            )}

            {/* Type 4: Upcharge Config */}
            {ruleTypeId === "4" && (
              <>
                <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
                  <Grid item xs={12} sm={8} md={6}>
                    <InputLabel>Upcharge List *</InputLabel>
                    <SelectFieldCustom
                      data-test-id='upcharge-list'
                      fullWidth
                      variant='outlined'
                      value={formData.upcharge_list_id}
                      onChange={(e) => this.handleInputChange("upcharge_list_id", e.target.value as string)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>Select Upcharge List</MenuItem>
                      {upchargeList.map((upcharge) => (
                        <MenuItem key={upcharge.id} value={upcharge.id}>
                          {upcharge.attributes.name}
                        </MenuItem>
                      ))}
                    </SelectFieldCustom>
                  </Grid>
                  <Grid item xs={12} sm={8} md={6} style={{ display: "flex", alignItems: "flex-end" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          data-test-id='requires-all-items'
                          checked={formData.requires_all_items}
                          onChange={(e) => this.setState({
                            formData: {
                              ...this.state.formData,
                              requires_all_items: e.target.checked
                            }
                          })}
                          color="primary"
                        />
                      }
                      label="Requires All Items"
                    />
                  </Grid>
                </Grid>
              </>
            )}

            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              {/* Start Date */}
              <Grid item xs={12} sm={8} md={3}>
                <InputLabel>Start Date *</InputLabel>
                <CustomStyledTextField
                  data-test-id='multiplier-start-date'
                  fullWidth={true}
                  variant='outlined'
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={formData.start_date}
                  onChange={(e) => this.handleInputChange("start_date", e.target.value)}
                  error={!!formErrors["start_date"]}
                />
                {formErrors["start_date"] && (
                  <div style={webStyle.errorText}>{formErrors["start_date"]}</div>
                )}
              </Grid>

              {/* End Date */}
              <Grid item xs={12} sm={8} md={3}>
                <InputLabel>End Date</InputLabel>
                <CustomStyledTextField
                  data-test-id='multiplier-end-date'
                  fullWidth={true}
                  variant='outlined'
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={formData.end_date}
                  onChange={(e) => this.handleInputChange("end_date", e.target.value)}
                  error={!!formErrors["end_date"]}
                />
                {formErrors["end_date"] && (
                  <div style={webStyle.errorText}>{formErrors["end_date"]}</div>
                )}
              </Grid>
            </Grid>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "32px",
                marginTop: "32px",
                marginBottom: "32px",
              }}
            >
              <SaveAndCancelButton
                data-test-id='cancel-multiplier-button'
                variant='contained'
                onClick={this.onCancel}
                size='medium'
                style={{ ...webStyle.cancelButton, textTransform: "none" }}
                disabled={isSubmitting}
              >
                Cancel
              </SaveAndCancelButton>
              <SaveAndCancelButton
                data-test-id='save-multiplier-button'
                variant='contained'
                onClick={this.onSave}
                size='medium'
                style={{ ...webStyle.saveButton, textTransform: "none" }}
                color='secondary'
                disabled={isSubmitting}
              >
                {isSubmitting ? "Updating..." : "Update"}
              </SaveAndCancelButton>
            </div>
          </div>
        </Box>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          data-test-id='snackbar-multiplier'
          open={!!this.state.snackBarMessage}
          autoHideDuration={3000}
          onClose={this.closeSnackBar}
        >
          <Alert severity={this.state.snackBarMessageType}>
            {this.state.snackBarMessage}
          </Alert>
        </Snackbar>
      </>
    );
  }
}

const webStyle = {
  mainContainer: {
    display: "flex",
    flexDirection: "column" as const,
    fontFamily: "Montserrat",
    padding: "32px",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    maxWidth: "1200px",
  },
  header: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "29px",
    color: "#000000",
    marginBottom: "16px",
  },
  warningContainer: {
    padding: "16px",
    fontWeight: 500,
    marginTop: "32px",
    width: "100%",
    borderRadius: "4px",
    fontFamily: "Montserrat",
    borderLeft: "4px solid  #204B9C",
    background: "rgba(32, 75, 156, 0.10)",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column" as const,
    width: "100%",
  },
  errorText: {
    color: "#f44336",
    fontSize: "12px",
    marginTop: "4px",
    fontFamily: "Montserrat",
  },
  cancelButton: {
    backgroundColor: "#FFFFFF",
    color: "#204B9C",
    border: "1px solid #204B9C",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    height: "56px",
    width: "184px",
    borderRadius: "8px",
  },
  saveButton: {
    backgroundColor: "#204B9C",
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    height: "56px",
    width: "184px",
    borderRadius: "8px",
  },
};

// Customizable Area End
